export enum NotificationMessageType {
    Sindri = 0,
    Chat = 1,
    News = 2,
}
